/**
 * Available hooks
 *
 * component.initialized(component)
 * elementInitialized(el, component)
 * element.removed(el, component)
 * message.sent(component, message)
 * message.failed(component)
 * message.received(component, response)
 * message.received(component, mutableHtmlContainer)
 * beforeElementUpdate(from, to, component)
 * element.updated(node, component)
 * message.processed(component)
 * interceptWireModelSetValue(el, value)
 * interceptWireModelAttachListener(el, directive, component, debounceIf)
 * directive(el, directive, component)
 *
 */

export default function() {
    window.Livewire.directive('submitall', (el, directive, component) => {
        const action = directive.method;
        el.addEventListener('submit', function(event) {
            event.preventDefault();
            component.call(action, Object.fromEntries(new FormData(event.target)));
        });
    });
}
